
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "ScrollableTabs14772509",
      {"classes":{"root":"ScrollableTabs14772509__root","nav":"ScrollableTabs14772509__nav","tab":"ScrollableTabs14772509__tab","selectedIndicator":"ScrollableTabs14772509__selectedIndicator","border":"ScrollableTabs14772509__border","itemsList":"ScrollableTabs14772509__itemsList"},"vars":{"wix-ui-tpa-scrollable-tabs-selected-indicator-color":"--wix-ui-tpa-scrollable-tabs-selected-indicator-color"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  